import { useQuery } from "@tanstack/react-query";

import { userService } from "@/services/user.service";

/**
 * Custom hook to fetch loyalty profile using TanStack Query.
 * Loads user identity (name, email, avatar), level, points, and point history.
 *
 * @param enabled - Set to false to disable auto-fetching (e.g., when user is not authenticated).
 */
export const useLoyaltyProfile = (enabled = true) => {
  return useQuery({
    queryKey: ["loyalty", "profile"],
    queryFn: () => userService.getProfile(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    enabled,
    retry: (failureCount, error) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const status = (error as any)?.response?.status;
      if (status === 401) return false;
      return failureCount < 2;
    },
  });
};
